const SCHEDULE_DATE_NO_TIME_NAME = 'scheduleDateForm';
const SCHEDULE_DATE_TIME_NAME = 'scheduleDateTimeForm';

const validate = (values, props) => {
  const errors = {};

  const activityIndex = props.initialValues.index;
  const activity = values.activities[activityIndex];

  if (!activity) return errors;

  if (
    activity.scheduleType === SCHEDULE_DATE_NO_TIME_NAME &&
    (!values.dates || !values.dates.startDate)
  ) {
    errors.multiDates = 'Starting date is required';
  } else if (
    activity.scheduleType === SCHEDULE_DATE_TIME_NAME &&
    !values.startingDate
  ) {
    errors.startingDate = 'Starting date is required';
  }

  if (activity.participants && activity.participants.length) {
    let participantsArrayErrors = [];
    let isValidParticipants = false;

    activity.participants.forEach((item, index) => {
      if (item.participants && parseInt(item.participants) > 0) {
        isValidParticipants = true;
      }

      participantsArrayErrors[index] = { participants: 'Error' };
    });

    if (!isValidParticipants) {
      errors.participants = {
        ...participantsArrayErrors,
        _error: 'Value for at least one category should be filled in'
      };
    }
  }

  if (
    !errors.participants &&
    activity.participants &&
    activity.participants.length
  ) {
    const availableParticipants = activity.maxParticipants;
    const participantsArrayErrors = [];
    let totalParticipants = 0;

    activity.participants.forEach((item, index) => {
      if (item.participants && item.participants.length) {
        totalParticipants += parseInt(item.participants);
      }
      participantsArrayErrors[index] = { participants: 'Error' };
    });

    if (totalParticipants > availableParticipants) {
      errors.participants = {
        ...participantsArrayErrors,
        _error: `The number of Guests can’t exceed ${availableParticipants}`
      };
    }
  }

  if (!!Object.keys(errors).length) {
    const errorsCopy = { ...errors };
    errors.activities = {
      [activityIndex]: errorsCopy
    };
  }

  return errors;
};

export default validate;
